export default "__VITE_ASSET__39e85059__"